import React from 'react';
import { BannerProps, money } from './BannerProps';

/**
 * Design 4: full-width photo, words over the dark side. Owner-approved
 * mockup #04. Falls back to a plain dark gradient block when there is no
 * uploaded photo — never an empty box.
 */
const PhotoWideBanner: React.FC<BannerProps> = ({ promotion }) => {
  const hasPhoto = !!promotion.imageUrl;
  const saving =
    promotion.wasTotalCents !== null && promotion.totalCents !== null
      ? promotion.wasTotalCents - promotion.totalCents
      : null;
  const caption = promotion.rows[0]?.label ?? promotion.body;
  const through = promotion.finePrint ?? (promotion.endsAt ? `through ${promotion.endsAt}` : null);

  return (
    <div
      style={{
        position: 'relative',
        height: 120,
        borderRadius: 6,
        overflow: 'hidden',
        background: hasPhoto ? '#0f172a' : 'linear-gradient(135deg,#1e293b,#64748b)',
        fontFamily: 'Helvetica, Arial, sans-serif',
      }}
    >
      {hasPhoto && (
        <img
          src={promotion.imageUrl as string}
          alt={promotion.name}
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
        />
      )}
      {hasPhoto && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(90deg, rgba(15,23,42,.86) 42%, rgba(15,23,42,.15))',
          }}
        />
      )}
      <div
        style={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          padding: '10px 14px',
          color: '#fff',
          boxSizing: 'border-box',
        }}
      >
        <div style={{ fontSize: 10, letterSpacing: '0.12em', opacity: 0.85, textTransform: 'uppercase' }}>
          {promotion.name}
        </div>
        <div style={{ fontSize: 19, fontWeight: 800, marginTop: 2, display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'baseline' }}>
          <span>{money(promotion.totalCents)}</span>
          {promotion.wasTotalCents !== null && (
            <span style={{ fontSize: 12, fontWeight: 400, textDecoration: 'line-through', opacity: 0.7 }}>
              {money(promotion.wasTotalCents)}
            </span>
          )}
        </div>
        <div style={{ fontSize: 10.5, marginTop: 3, opacity: 0.9, overflowWrap: 'break-word' }}>
          {[caption, saving !== null ? `save ${money(saving)}` : null, through].filter(Boolean).join(' · ')}
        </div>
      </div>
    </div>
  );
};

export default PhotoWideBanner;
